/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import RemoveProjectsForm from './RemoveProjectsForm/RemoveProjectsForm';
import RemoveProjectsSuccess from './RemoveProjectsSuccess/RemoveProjectsSuccess';
import RemoveProjectsError from './RemoveProjectsError/RemoveProjectsError';
import Form from '../../../../../forms/_.extend';

import Loading from 'components/Loading/Loading';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveProjects extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore }: TypeProps = this.props;

    const costCenter: Object = this.props.costCenter;

    const fields: Array<Object> = [
      {
        name: 'removeProjects',
        label: t('general:actions.select_projects'),
        title: 'Select Project(s)',
        fields: [
          {
            name: 'projectIds',
            label: '',
            rules: 'required|array',
            value: [],
            placeholder: 'Project code or name...',
          },
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required|string',
            value: '',
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { projectIds, reason }: Object = data.values().removeProjects;

        actionDrawerStore.removeProjectsFromCC(costCenter.id, {
          ids: projectIds,
          remove_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Remove Project(s)',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const costCenter: Object = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.remove_projects')} />
          <RemoveProjectsError {...costCenter} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.remove_projects')} />
          <RemoveProjectsSuccess {...costCenter} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.remove_projects')} />
        <RemoveProjectsForm {...costCenter} form={this.createForm()} />
      </div>
    );
  }
}
